import { useSendAnvisaAuthorizationStep } from './useSendAnvisaAuthorizationStep'
import { SendAnvisaAuthorizationStepUI } from './SendAnvisaAuthorizationStepUI'

export const SendAnvisaAuthorizationStep = () => {
  const props = useSendAnvisaAuthorizationStep()
  return <SendAnvisaAuthorizationStepUI {...props} />
}
